import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a7a13ce&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6a7a13ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7a13ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a7a13ce')) {
      api.createRecord('6a7a13ce', component.options)
    } else {
      api.reload('6a7a13ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a7a13ce&scoped=true&lang=pug", function () {
      api.rerender('6a7a13ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/q&a/index.vue"
export default component.exports